export default "__VITE_ASSET__D0Go_q25__"